/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AllegatoDtoFromJSON, AllegatoDtoToJSON, } from './AllegatoDto';
/**
 * Check if a given object implements the SoggettoDto interface.
 */
export function instanceOfSoggettoDto(value) {
    let isInstance = true;
    return isInstance;
}
export function SoggettoDtoFromJSON(json) {
    return SoggettoDtoFromJSONTyped(json, false);
}
export function SoggettoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idEsponente': !exists(json, 'idEsponente') ? undefined : json['idEsponente'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'genere': !exists(json, 'genere') ? undefined : json['genere'],
        'dataDiNascita': !exists(json, 'dataDiNascita') ? undefined : (new Date(json['dataDiNascita'])),
        'statoDiNascita': !exists(json, 'statoDiNascita') ? undefined : json['statoDiNascita'],
        'comuneDiNascita': !exists(json, 'comuneDiNascita') ? undefined : json['comuneDiNascita'],
        'provinciaDiNascita': !exists(json, 'provinciaDiNascita') ? undefined : json['provinciaDiNascita'],
        'siglaProvinciaDiNascita': !exists(json, 'siglaProvinciaDiNascita') ? undefined : json['siglaProvinciaDiNascita'],
        'prefissoTel': !exists(json, 'prefissoTel') ? undefined : json['prefissoTel'],
        'numeroTel': !exists(json, 'numeroTel') ? undefined : json['numeroTel'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'capResidenza': !exists(json, 'capResidenza') ? undefined : json['capResidenza'],
        'comuneResidenza': !exists(json, 'comuneResidenza') ? undefined : json['comuneResidenza'],
        'provinciaResidenza': !exists(json, 'provinciaResidenza') ? undefined : json['provinciaResidenza'],
        'siglaProvinciaResidenza': !exists(json, 'siglaProvinciaResidenza') ? undefined : json['siglaProvinciaResidenza'],
        'nazioneResidenza': !exists(json, 'nazioneResidenza') ? undefined : json['nazioneResidenza'],
        'indirizzoResidenza': !exists(json, 'indirizzoResidenza') ? undefined : json['indirizzoResidenza'],
        'civicoResidenza': !exists(json, 'civicoResidenza') ? undefined : json['civicoResidenza'],
        'hasCarichePubbliche': !exists(json, 'hasCarichePubbliche') ? undefined : json['hasCarichePubbliche'],
        'hasCarichiPendenti': !exists(json, 'hasCarichiPendenti') ? undefined : json['hasCarichiPendenti'],
        'dichiarazioneDLGS': !exists(json, 'dichiarazioneDLGS') ? undefined : json['dichiarazioneDLGS'],
        'caricaRicoperta': !exists(json, 'caricaRicoperta') ? undefined : json['caricaRicoperta'],
        'documentoRilasciatoDa': !exists(json, 'documentoRilasciatoDa') ? undefined : json['documentoRilasciatoDa'],
        'numeroDocumento': !exists(json, 'numeroDocumento') ? undefined : json['numeroDocumento'],
        'dataRilascioDocumento': !exists(json, 'dataRilascioDocumento') ? undefined : (new Date(json['dataRilascioDocumento'])),
        'dataScadenzaDocumento': !exists(json, 'dataScadenzaDocumento') ? undefined : (new Date(json['dataScadenzaDocumento'])),
        'tipoDocumento': !exists(json, 'tipoDocumento') ? undefined : json['tipoDocumento'],
        'autoritaEmanante': !exists(json, 'autoritaEmanante') ? undefined : json['autoritaEmanante'],
        'oggettoProvvedimento': !exists(json, 'oggettoProvvedimento') ? undefined : json['oggettoProvvedimento'],
        'dataEmissione': !exists(json, 'dataEmissione') ? undefined : (new Date(json['dataEmissione'])),
        'statoProvvedimento': !exists(json, 'statoProvvedimento') ? undefined : json['statoProvvedimento'],
        'tipoSoggetto': !exists(json, 'tipoSoggetto') ? undefined : json['tipoSoggetto'],
        'fullfiled': !exists(json, 'fullfiled') ? undefined : json['fullfiled'],
        'invitationRequest': !exists(json, 'invitationRequest') ? undefined : json['invitationRequest'],
        'elencoAllegati': !exists(json, 'elencoAllegati') ? undefined : (json['elencoAllegati'].map(AllegatoDtoFromJSON)),
        'conto': !exists(json, 'conto') ? undefined : json['conto'],
        'fatca': !exists(json, 'fatca') ? undefined : json['fatca'],
    };
}
export function SoggettoDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'idEsponente': value.idEsponente,
        'nome': value.nome,
        'cognome': value.cognome,
        'codiceFiscale': value.codiceFiscale,
        'genere': value.genere,
        'dataDiNascita': value.dataDiNascita === undefined ? undefined : (value.dataDiNascita.toISOString()),
        'statoDiNascita': value.statoDiNascita,
        'comuneDiNascita': value.comuneDiNascita,
        'provinciaDiNascita': value.provinciaDiNascita,
        'siglaProvinciaDiNascita': value.siglaProvinciaDiNascita,
        'prefissoTel': value.prefissoTel,
        'numeroTel': value.numeroTel,
        'email': value.email,
        'capResidenza': value.capResidenza,
        'comuneResidenza': value.comuneResidenza,
        'provinciaResidenza': value.provinciaResidenza,
        'siglaProvinciaResidenza': value.siglaProvinciaResidenza,
        'nazioneResidenza': value.nazioneResidenza,
        'indirizzoResidenza': value.indirizzoResidenza,
        'civicoResidenza': value.civicoResidenza,
        'hasCarichePubbliche': value.hasCarichePubbliche,
        'hasCarichiPendenti': value.hasCarichiPendenti,
        'dichiarazioneDLGS': value.dichiarazioneDLGS,
        'caricaRicoperta': value.caricaRicoperta,
        'documentoRilasciatoDa': value.documentoRilasciatoDa,
        'numeroDocumento': value.numeroDocumento,
        'dataRilascioDocumento': value.dataRilascioDocumento === undefined ? undefined : (value.dataRilascioDocumento.toISOString()),
        'dataScadenzaDocumento': value.dataScadenzaDocumento === undefined ? undefined : (value.dataScadenzaDocumento.toISOString()),
        'tipoDocumento': value.tipoDocumento,
        'autoritaEmanante': value.autoritaEmanante,
        'oggettoProvvedimento': value.oggettoProvvedimento,
        'dataEmissione': value.dataEmissione === undefined ? undefined : (value.dataEmissione.toISOString()),
        'statoProvvedimento': value.statoProvvedimento,
        'tipoSoggetto': value.tipoSoggetto,
        'fullfiled': value.fullfiled,
        'invitationRequest': value.invitationRequest,
        'elencoAllegati': value.elencoAllegati === undefined ? undefined : (value.elencoAllegati.map(AllegatoDtoToJSON)),
        'conto': value.conto,
        'fatca': value.fatca,
    };
}
